import { createProgressActions, createActionCreators } from '../utils';
import { createAction } from 'redux-actions';

import { _handleSubmissionError } from '../../containers/utils'

const login = createActionCreators(createProgressActions('AUTHENTICATE'), {
	reject: _handleSubmissionError
});
const register = createActionCreators(createProgressActions('REGISTER'));

const DEAUTHENTICATE = 'DEAUTHENTICFATE';
const logout = createAction(DEAUTHENTICATE);

const SET_COOKIE = 'SET_COOKIE';
const CLEAR_COOKIE = 'CLEAR_COOKIE';
const setCookie = createAction(SET_COOKIE);
const clearCookie = createAction(CLEAR_COOKIE);

const actions = {
    logout: DEAUTHENTICATE,
    AUTHENTICATE: login.names.START,
  DEAUTHENTICATE,
	SET_COOKIE,
	CLEAR_COOKIE,
};

export default actions;
export { login, register, logout, setCookie, clearCookie };



// WEBPACK FOOTER //
// ./src/app/models/Auth/actions.ts